export function dateFromString(dateString) {
  if (!dateString) {
    return undefined;
  }
  let splitString = dateString.split(/[- :]/).map(s => parseInt(s));
  let date;
  if (splitString[3]) {
    date = new Date(splitString[0], splitString[1] - 1, splitString[2], splitString[3] - 1, splitString[4], splitString[5]);
  } else {
    date = new Date(splitString[0], splitString[1] - 1, splitString[2]);
  }
  return date;
}
export function formatDate(dateString, format) {
  let date = dateFromString(dateString);
  if(format === 'datetime') {
    return `le ${date.getDate()} ${['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'][date.getMonth()]} à ${('00'+(date.getHours()+2)).slice(-2)}h${('00' + date.getMinutes()).slice(-2)}`
  } else {
    return `le ${date.getDate()} ${['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Decembre'][date.getMonth()]} ${date.getFullYear()}`
  }
}

export function formatDateTime(dateString) {
  return formatDate(dateString, 'datetime')

}

window.uploadAvatar = async (id, file) => {
  let formData = new FormData()
  formData.append('file', file)
  formData.append('v', id * 4 + 52264)

  let headers = { 'Content-Type': 'multipart/form-data' }
  try {
    let response = axios.post(process.env.VUE_APP_BACKEND_URL + '/avatars', formData, { headers })
    return response
  } catch (ex) {
    console.log('FAILURE!!', ex);
  }
}
